export default __webpack_public_path__ + "static/media/Foto-23.e8020d40.png";